import { render, staticRenderFns } from "./anamneseBogenCreate.vue?vue&type=template&id=2c9c5a9a&scoped=true"
import script from "./anamneseBogenCreate.vue?vue&type=script&lang=js"
export * from "./anamneseBogenCreate.vue?vue&type=script&lang=js"
import style0 from "./anamneseBogenCreate.vue?vue&type=style&index=0&id=2c9c5a9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c5a9a",
  null
  
)

export default component.exports